import type { JsonLdSchema } from '@/utils/structuredData';
import { serializeJsonLd } from '@/utils/structuredData';

interface Props {
    schema: JsonLdSchema;
}

export function JsonLd({ schema }: Props) {
    return (
        <script
            type="application/ld+json"
            // serializeJsonLd escapes < so JSON-LD cannot break out of this script element.
            dangerouslySetInnerHTML={{ __html: serializeJsonLd(schema) }}
        />
    );
}
